import { motion } from 'framer-motion'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React, { Fragment, useMemo } from 'react'

import ImageByWidthDevice from '@/components/ImageByWidthDevice'
import { introBottomVariants, introLeftVariants, introOpacityVariants } from '@/config/const'
import { getHomeInvestors } from '@/services/home'
import { HomeBannerListRequest } from '@/types/home'
import { useAppSelector } from '@/utils/hooks'

const TopInvestor: React.FC = () => {
  const { t } = useTranslation()
  const router = useRouter()

  const request: HomeBannerListRequest = useMemo(() => {
    return {
      params: { skip: 0, limit: 1000 },
      headers: { 'Accept-Language': String(router.locale) },
    }
  }, [])

  const { data: investors } = useAppSelector(getHomeInvestors.select(request))

  if (investors?.data.items) {
    return (
      <div className='container flex flex-col items-center gap-6 py-8 md:gap-12.5 md:py-12.5'>
        <div className='flex flex-col items-center gap-4'>
          <motion.h2
            className='text-center text-2xl font-bold leading-8 md:text-3.5xl md:leading-10'
            initial='hide'
            whileInView='show'
            viewport={{ once: true }}
            variants={introLeftVariants}
          >
            {investors?.data.title}
          </motion.h2>

          <motion.div
            className='description w-full max-w-[621px] break-words text-center text-sm tracking-[-0.176px] md:text-base'
            dangerouslySetInnerHTML={{ __html: investors?.data.description }}
            initial='hide'
            whileInView='show'
            viewport={{ once: true }}
            variants={introOpacityVariants}
          />
        </div>

        <motion.div
          className='flex w-full flex-wrap items-center justify-center gap-x-[21.5px] gap-y-1.5 md:gap-x-[52.5px] md:gap-y-6'
          initial='hide'
          whileInView='show'
          viewport={{ once: true }}
          variants={introOpacityVariants}
        >
          {investors?.data.items.map((investor) => (
            <Fragment key={investor.xid}>
              {investor?.imageFiles && (
                <ImageByWidthDevice
                  images={investor?.imageFiles}
                  alt={investor?.imageFiles?.desktop.fileName ?? ''}
                  className='w-25 md:w-45'
                />
              )}
            </Fragment>
          ))}
        </motion.div>

        <motion.p
          className='text-base font-bold'
          initial='hide'
          whileInView='show'
          viewport={{ once: true }}
          variants={introBottomVariants}
        >
          {t('common:andManyMore')}
        </motion.p>
      </div>
    )
  }
  return null
}

export default TopInvestor
